document.addEventListener('DOMContentLoaded', () => {
  const absoluteUrl = (value, origin) => {
    if (!value) return '';
    try { return new URL(value, origin).href; } catch (_) { return '' }
  };

  const money = value => {
    if (typeof value === 'string') return value;
    const amount = value && (value.amount ?? value.attributes?.amount);
    const currency = value && (value.currency ?? value.attributes?.currency) || 'GBP';
    if (!Number.isFinite(Number(amount))) return '';
    return new Intl.NumberFormat('en-GB', { style: 'currency', currency, maximumFractionDigits: 2 })
      .format(Number(amount) / 100);
  };

  const normalize = (payload, origin) => {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.items)) return payload.items;
    if (!Array.isArray(payload?.data)) return [];

    const included = new Map((payload.included || []).map(entity => [`${entity.type}:${entity.id}`, entity]));
    return payload.data.map(listing => {
      const attributes = listing.attributes || {};
      const publicData = attributes.publicData || {};
      const imageRef = listing.relationships?.images?.data?.[0];
      const image = imageRef && included.get(`${imageRef.type}:${imageRef.id}`);
      const variants = image?.attributes?.variants || {};
      const imageUrl = variants['scaled-large']?.url || variants['landscape-crop2x']?.url ||
        variants['default']?.url || image?.attributes?.url || '';
      return {
        id: listing.id,
        title: attributes.title,
        artist: publicData.ArtistField || publicData.artist || publicData.attribution || '',
        date: publicData.Centuryfield || publicData.century || publicData.date || '',
        price: money(attributes.price),
        image: imageUrl,
        url: absoluteUrl(attributes.url || `/l/${listing.id}`, origin)
      };
    });
  };

  const card = (item, origin, showHeart) => {
    const article = document.createElement('article');
    article.className = 'dga-card';
    const link = document.createElement('a');
    link.href = absoluteUrl(item.url || item.href, origin) || origin;
    const imageWrap = document.createElement('div');
    imageWrap.className = 'dga-card__image';
    const imageUrl = absoluteUrl(item.image || item.imageUrl || item.thumbnail, origin);
    if (imageUrl) {
      const image = document.createElement('img');
      image.src = imageUrl;
      image.alt = item.imageAlt || item.title || 'Marketplace artwork';
      image.loading = 'lazy';
      image.decoding = 'async';
      imageWrap.append(image);
    }
    if (showHeart) {
      const heart = document.createElement('span');
      heart.className = 'dga-card__heart';
      heart.setAttribute('aria-hidden', 'true');
      heart.textContent = '♡';
      imageWrap.append(heart);
    }
    link.append(imageWrap);
    [['h3', 'dga-serif', item.title], ['p', 'dga-meta', item.artist], ['p', 'dga-meta', item.date || item.century], ['p', 'dga-price dga-serif', item.price]].forEach(([tag, className, text]) => {
      if (!text) return;
      const element = document.createElement(tag);
      element.className = className;
      element.textContent = text;
      link.append(element);
    });
    article.append(link);
    return article;
  };

  document.querySelectorAll('[data-dga-feed]').forEach(async section => {
    const url = section.dataset.dgaFeed;
    const container = section.querySelector('[data-dga-listings]');
    if (!url || !container) return;
    container.setAttribute('aria-busy', 'true');
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 12000);
    try {
      const response = await fetch(url, { credentials: 'omit', headers: { Accept: 'application/json' }, signal: controller.signal });
      if (!response.ok) throw new Error('Feed unavailable');
      const origin = section.dataset.dgaMarketplaceOrigin || 'https://marketplace.darkgloomyart.com';
      const limit = Math.max(3, Math.min(12, Number(section.dataset.dgaLimit) || 5));
      const items = normalize(await response.json(), origin).filter(item => item && item.title && (item.image || item.imageUrl || item.thumbnail)).slice(0, limit);
      if (!items.length) throw new Error('Feed contains no usable listings');
      const fragment = document.createDocumentFragment();
      const showHeart = section.dataset.dgaShowHeart === 'true' || Boolean(section.querySelector('.dga-card__heart'));
      items.forEach(item => fragment.append(card(item, origin, showHeart)));
      container.replaceChildren(fragment);
      section.dispatchEvent(new CustomEvent('dga:feed-ready', { detail: items }));
    } catch (_) {
      const message = document.createElement('p');
      message.className = 'dga-feed-unavailable';
      const link = document.createElement('a');
      link.href = 'https://marketplace.darkgloomyart.com/s';
      link.textContent = 'Browse artworks on the marketplace →';
      message.append(link);
      container.replaceChildren(message);
    } finally {
      clearTimeout(timeout);
      container.removeAttribute('aria-busy');
    }
  });
});
